import React, { useEffect, useState } from "react";
import { withRouter } from 'react-router-dom';
import withCurrentUser from '../../../hocs/with_current_user.js.jsx';
import withShowToast from '../../../hocs/with_show_toast.js';
import { compose } from 'redux';

import I18n from "../../../base/i18n.js.jsx";
import QuestionnaireFields from "../../../base/user_fields/questionnaire_fields.js";

import PageContainer from "./components/page_container.js";
import Form from "./components/form.js";
import FormWrapper from "./components/form_wrapper.js";
import NavBlock from "./components/nav_block.js";
import BackButtonBlock from "./components/back_button_block.js";
import SubmitButton from "./components/submit_button.js";
import Title from "./components/title.js";
import LoadingIndicator from "./components/loading_indicator.js";

import CurrentUserQuestionnaireUseCase from "../../../use_cases/users/questionnaires/current_user_questionnaire_use_case.js";
import UpdateCurrentUserQuestionnaireUseCase from "../../../use_cases/users/questionnaires/update_current_user_questionnaire_use_case.js";

const ProfileQuestionnairePage = (props) => {
  const { showSuccessMessage, showServerErrorIfNeed } = props;

  const [loading, setLoading] = useState(true);
  const [questions, setQuestions] = useState([]);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    CurrentUserQuestionnaireUseCase.execute()
    .then((result) => {
      const { data: { questionnaire: { data } } } = result;
      setQuestions(data);
      setLoading(false);
    })
    .catch((result) => {
      setLoading(false);
      showServerErrorIfNeed(result);
    })
  }, []);

  const onChange = (questions) => {
    setQuestions(questions)
  }

  const onSubmit = () => {
    setSubmitting(true);
    UpdateCurrentUserQuestionnaireUseCase.execute({data: questions})
    .then((result) => {
      const { data: { questionnaire: { data } } } = result;
      setQuestions(data);
      setSubmitting(false);
      showSuccessMessage(I18n.t("shared.toast.successfully_saved"));
    })
    .catch((result) => {
      setSubmitting(false);
      showServerErrorIfNeed(result);
    })
  }

  return (
    <PageContainer>
      <Title />
      <NavBlock needReplace = { true } />
      <FormWrapper>
        <BackButtonBlock />
        <Form onSubmit = { onSubmit } >
          { loading && <LoadingIndicator />}
          {
            !loading &&
            <QuestionnaireFields questions = { questions }
                                 onChange = { onChange }
                                 showDisclaimer = { true } />
          }
          <SubmitButton disabled = { loading || submitting } />
        </Form>
      </FormWrapper>
    </PageContainer>
  );
}

export default compose(withShowToast, withCurrentUser, withRouter)(ProfileQuestionnairePage);
